import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Header used by the backend to scope every request to a single organization. */
export const ORGANIZATION_HEADER = 'Organization-Id';

/**
 * Attaches the configured organization to every request targeting our own API.
 *
 * Fail-closed by design: if no organization is configured the request is rejected
 * instead of falling back to a default organization id.
 */
@Injectable()
export class OrganizationInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Never leak the tenant id to third-party endpoints (maps, CDNs, telemetry).
        if (!req.url.startsWith(environment.apiUrl)) {
            return next.handle(req);
        }

        const organizationId = environment.org_id;
        if (organizationId === null || organizationId === undefined) {
            return throwError(() => new Error(
                'No organization configured (environment.org_id). Request aborted to prevent cross-tenant access.'
            ));
        }

        const scopedReq = req.clone({
            setHeaders: {
                [ORGANIZATION_HEADER]: String(organizationId)
            }
        });
        return next.handle(scopedReq);
    }

}
